import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Country} from '../../../../models/country';
import {Platform} from '../../../../models/platform';
import {Campaign} from '../../../../models/campaign';
import {InfluencerGroup} from '../../../../models/influencer-group';
import {MeasureSearchCriteria} from '../../../../models/measure/measure-search-criteria';
import {Project} from '../../../../models/project/project';
import {Report} from '../../../../models/measure/report';
import {
  ActionSource,
  ActivePages,
  EventTrackerService,
  Page,
  TargetType,
  UserActionType
} from '../../../services/event-tracker/event-tracker.service';
import {UserService} from '../../../services/user.service';
import { ProjectSelectionComponent } from '../project-selection/project-selection.component';

@Component({
  selector: 'measure-filter',
  templateUrl: './measure-filter.component.html',
  styleUrls: ['./measure-filter.component.scss']
})
export class MeasureFilterComponent {

  @ViewChild('projectSelection')
  projectSelection: ProjectSelectionComponent;

  @Input()
  public countryList: Country[];
  @Input()
  public platFormList: Platform[];
  @Input()
  public campaignList: Campaign[];
  @Input()
  public influencerGroupList: InfluencerGroup[];
  @Input()
  public projectList: any[];
  @Input()
  public measureSearchCriteria: MeasureSearchCriteria = new MeasureSearchCriteria();
  @Input()
  selectedReport: Report;

  @Output()
  public generateReportEvent: EventEmitter<MeasureSearchCriteria> = new EventEmitter<MeasureSearchCriteria>();
  @Output()
  public editOrCreateProjectEvent: EventEmitter<Project> = new EventEmitter<Project>();
  @Output()
  public afterDeleteProjectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public showSearchBarEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public clearFilterEvent: EventEmitter<any> = new EventEmitter<any>();
  // this flag use to know when the search bar is open/close. Default is open
  public showSearchBar = true;

  constructor(private eventTracker: EventTrackerService, private userService: UserService) { }

  clearFilter() {
    this.clearFilterEvent.emit();
  }

  generateReport(e, filter, mixPannelTargetType) {
    if (e && this.selectedReport) {
      this.segementTrackReportView(e.id, e.name, mixPannelTargetType);
    }
    // #160141066 Only Allow Selecting 1 Item When Rendering Reports
    this.measureSearchCriteria.project_id = undefined;
    this.measureSearchCriteria.influencerGroup = undefined;
    this.measureSearchCriteria.campaign_id = undefined;
    if (e) {
      this.measureSearchCriteria[filter] = e.id;
    }
    this.generateReportEvent.emit(this.measureSearchCriteria);
  }

  showHideSearchbar(e) {
    this.showSearchBar = !this.showSearchBar;
    this.showSearchBarEvent.emit(this.showSearchBar);
  }

  onEditOrCreateProject(project) {
    if (project.id > 0) {
      project.keywords = project.projectKeywords.map(item => item.keyword);
      project.countries = project.projectCountries.map(item => item.country.id);
      // track select project
      this.eventTracker.trackUserAction(UserActionType.VIEW, Page.PROJECT, {
        id: project.id,
        name: project.name,
        type: 'Project'
      }, undefined, undefined, {
        type: ActivePages.MEASURE
      });
    }
    this.editOrCreateProjectEvent.emit(project);
  }

  afterDeleteProjectCallback(projectId) {
    if (this.measureSearchCriteria.project_id === projectId) {
      this.measureSearchCriteria.project_id = null;
    }
    this.afterDeleteProjectEvent.emit(projectId);
  }

  closeTooltipManually(t) {
    if (t) {
      t.close();
    }
  }

  private segementTrackReportView(filterId, filterName, filterType) {
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.MEASURE, {
      id: filterType,
      name: filterType,
      type: TargetType.FILTER,
      filterName: filterName,
      filterId: filterId
    }, {
      action: UserActionType.TOGGLE,
      source: ActionSource.PAGE,
    }, {
      id: this.selectedReport.id,
      name: this.selectedReport.name
    }, {
      type: ActivePages.MEASURE,
      name: this.selectedReport.name,
      id: this.selectedReport.id
    });
  }

  get isFreeUser() {
    return this.userService.isFreeUser();
  }

  get projectDataForSegment() {
    return {
      action: UserActionType.ACTION,
      item: Page.PROJECT,
      target: {
        type: TargetType.PROJECT,
      },
      params: {
        action: UserActionType.UPDATE
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-filter/measure-filter.component.ts